
<template>
    <mission-detail 
        @nextMission="nextMission"
        @unlockMoreMission="unlockMoreMission"
        @updateMissionData="updateMissionData"
        v-if="currentMission"
        v-show="!isShowDetaileMission" 
        :mission="currentMission"
    ></mission-detail>
</template>

<script>
import missionDetail from "@/code-lab/component/mission/mission-detail.vue";
import missionMix from '@/code-lab/component/mission/mission-mix.js'
import { mapState } from 'vuex'
export default {
    mixins: [ missionMix ],
    data () {
        return {
            hasTaskRouteVersion: ['public', 'family']
        }
    },
    components: {
        missionDetail
    },
    computed: {
        ...mapState('introStore', {
            isShowDetaileMission: o => o.currentExe === "simulatorDB" && o.show
        }),
        ...mapState('missionList', {
            currentCategoryId: 'currentCategoryId',
            currentMissionId: 'currentMissionId',
            resizeTimer: 'resizeTimer',
            categoryList: 'categoryListCp'
            
        }),
        ...mapState({
            currentVersion: 'currentVersion',
            currentMission: "currentMission",
            getMissionListCmd: state => state.currentVersion === "public" ? "get_public_mission_list" : "get_mission_list",
            getMissionCategoryCmd: state => state.currentVersion === "public" ? "get_public_mission_category_list" : "get_mission_category_list",
            getMissionCmd: state => state.currentVersion === "public" ? "get_public_mission" : "get_mission",
        }),
    },
    methods: {
        updateMissionData(mission){
            let {missionId, missionCategoryId} = mission;
            if(this.categoryList && this.categoryList.payload){
                let category = this.categoryList.payload.find(item => item.missionCategoryId === missionCategoryId);
                if(category){
                    let missionIndex = category.list.payload.findIndex(item => item.missionId === missionId);
                    if(missionIndex >= 0){
                        category.list.payload.splice(missionIndex, 1, mission);
                    }
                }
            }
        },
        unlockMoreMission () {
            this.unlockMoreMission$()
        },

        getNextMissionCategoryById(missionCategoryId){
            if(this.categoryList){
                let currentCategoryIndex = this.categoryList.payload.findIndex(item => item.missionCategoryId === missionCategoryId);
                if(currentCategoryIndex >= 0){
                    return this.categoryList.payload[currentCategoryIndex + 1] || null;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },
        getMissionCategoryById(missionCategoryId){
            if(this.categoryList){
                return this.categoryList.payload.find(item => item.missionCategoryId === missionCategoryId);
            } else {
                return null;
            }
        },
        getNextMission(mission){
            let {section, missionCategoryId} = mission;
            let currentCategory = this.getMissionCategoryById(missionCategoryId);
            let nextMission = mission.nextMission || currentCategory.list.payload.find(item => item.section === section + 1);
            if(!nextMission){
                let nextCategory = this.getNextMissionCategoryById(missionCategoryId);
                if(nextCategory){
                    nextMission = nextCategory.list.payload.find(item => item.section === 1) ||  nextCategory.list.payload[0] || null;
                }
            }
            return nextMission;
        },
        onSelectMission (mission) {
            if (!mission.lock$) {
                mission.nextMission = this.getNextMission(mission);
                
                this.c({ currentMissionId: mission.missionId })
                if (this.hasTaskRouteVersion.includes(this.currentVersion)) {
                    this.$store.commit('SELECTEDMENUERIGHT', null)
                    this.$store.commit("SET_CURRENT_MISSION", mission)
                    this.$store.commit("SHOW_MISSION_LIST", false)
                }
            } else {
                console.log(this.$t( "code-lab/component/mission/mission-details-wrapper.vue_0" ));
            }
        },
        nextMission(){
            let currentMission = this.currentMission;
            if(currentMission && currentMission.nextMission){
                let nextMission = currentMission.nextMission;
                this.$store.commit("SET_CURRENT_MISSION", null);
                
                this.$nextTick(() => {
                    this.onSelectMission(nextMission);
                });
            }
        },
        c (payload, type = 'missionList/update') {
            this.$store.commit(type, payload)
        },
    },
}
</script>
